import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";
export default _Object$freeze({
  PUBLIC: 'PUBLIC',
  VIP: 'VIP',
  PRIVATE_INVITATION: 'PRIVATE_INVITATION'
});